import { TranslateResult } from 'vue-i18n';

export class UserProgressTarget {
    public name: string | TranslateResult;
    public value: number;
    public max: number;

    constructor(name: string | TranslateResult, value: number, max: number) {
        this.name = name;
        this.value = value;
        this.max = max;
    }

    public progressValue(): number {
        return Math.floor((100 * this.value) / this.max);
    }

    public progressName(): string {
        return `${this.value} / ${this.max}`;
    }
}

export class UserBadge {
    public title: string;
    public progress: string;
    public description: TranslateResult;
    public imgCoin: string;
    public imgBanner: string;
    public achieved: boolean;
}
